var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.678 2.143a6 6 0 013.764.372.667.667 0 10.543-1.218A7.333 7.333 0 1015.332 8v-.614a.667.667 0 00-1.333 0V8a6 6 0 11-7.322-5.856zm8.46.995a.667.667 0 00-.943-.942L8 8.397 6.47 6.87a.667.667 0 00-.942.943l2 2a.667.667 0 00.943 0l6.666-6.674z"
  })));
}

export default SvgCheckCircle;